/* Patamora v8: color y talla en desplegables separados.
   Los <select> con data-pm-opt-names (y data-opts en cada opción) se quedan ocultos como fuente de la
   variante: se pinta un desplegable por opción y, al cambiar, se elige la variante y se avisa con un
   "change" en el select original, así el carrito, los packs y "Completa tu pedido" funcionan igual. */

const SOURCE = 'select[data-pm-opt-names]';
// En tarjetas pequeñas (carrito, "más productos") la talla larga no cabe: se enseña talla y peso.
const COMPACT = '.pm-upsell, .pm-card, .pm-bundle';
let uid = 0;

// "S · pecho 34 cm (1-2 kg)" → "S · 1-2 kg"; "XS · 3-5 kg (chaleco XS + orejeras S)" → "XS · 3-5 kg".
function shortLabel(value) {
  const kg = value.match(/\(([^)]*kg)\)/);
  if (kg) return `${value.split(' · ')[0]} · ${kg[1]}`;
  return value.replace(/\s*\([^)]*\)\s*$/, '');
}

function splitSelect(source) {
  const names = source.dataset.pmOptNames.split('|');
  const options = [...source.options];
  if (names.length < 2 || options.some((o) => !o.dataset.opts)) return;

  const variants = options.map((o) => ({ option: o, values: o.dataset.opts.split('|'), available: !o.disabled }));
  const label = source.getAttribute('aria-label') || '';
  const of = label.includes(' de ') ? label.slice(label.indexOf(' de ')) : '';
  const current = () => (variants.find((v) => v.option.value === source.value) || variants[0]).values;
  const text = source.closest(COMPACT) ? shortLabel : (v) => v;

  const box = document.createElement('span');
  box.className = 'pm-optsel';
  box.style.minWidth = '0';
  box.pmSource = source;

  const selects = names.map((name, i) => {
    const select = document.createElement('select');
    select.className = 'pm-optsel__select';
    select.id = `pm-optsel-${++uid}`;
    select.style.minWidth = '0';
    select.style.maxWidth = '100%';
    select.setAttribute('aria-label', `${name}${of}`);
    for (const value of new Set(variants.map((v) => v.values[i]))) {
      const o = new Option(text(value), value);
      if (o.text !== value) o.title = value;
      select.add(o);
    }
    box.append(select);
    return select;
  });

  // Marca "agotado" lo que no existe con lo que hay elegido en los otros desplegables (se puede elegir igual).
  const refresh = () => {
    const cur = current();
    selects.forEach((select, i) => {
      select.value = cur[i];
      for (const o of select.options) {
        const ok = variants.some((v) => v.available && v.values[i] === o.value && v.values.every((x, j) => j === i || x === cur[j]));
        o.textContent = ok ? text(o.value) : `${text(o.value)} · agotado`;
      }
    });
  };

  box.addEventListener('change', (event) => {
    event.stopPropagation();
    const i = selects.indexOf(event.target);
    const wanted = selects.map((s) => s.value);
    const same = (v) => v.values.every((x, j) => x === wanted[j]);
    // Si esa combinación no hay, se queda el valor que acabas de tocar y se ajusta el otro.
    const pick =
      variants.find((v) => v.available && same(v)) ||
      variants.find((v) => v.available && v.values[i] === wanted[i]) ||
      variants.find(same);
    if (pick && pick.option.value !== source.value) {
      source.value = pick.option.value;
      source.dispatchEvent(new Event('change', { bubbles: true }));
    }
    refresh();
  });

  source.hidden = true;
  source.classList.add('pm-optsel-src');
  source.before(box);
  const sourceLabel = source.id && document.querySelector(`label[for="${CSS.escape(source.id)}"]`);
  if (sourceLabel) sourceLabel.htmlFor = selects[0].id;
  refresh();
}

// El carrito lateral se repinta entero: se vuelve a partir lo que llegue nuevo.
function run() {
  document.querySelectorAll(SOURCE).forEach((source) => {
    const prev = source.previousElementSibling;
    const isBox = prev && prev.classList.contains('pm-optsel');
    if (isBox && prev.pmSource === source && source.hidden) return;
    if (isBox) prev.remove();
    splitSelect(source);
  });
}

run();
let queued = false;
new MutationObserver(() => {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    run();
  });
}).observe(document.body, { childList: true, subtree: true });